var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0037H22.86V17.7187H24V12.0037Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 17.7188H21.7125V19.9988H22.86V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 9.71625H21.7125V12.0037H22.86V9.71625Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7125 19.9987H20.5725V22.2862H21.7125V19.9987Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7125 8.56873H20.5725V9.71623H21.7125V8.56873Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 22.2863H19.425V23.4263H20.5725V22.2863Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 15.4312H19.425V17.7187H20.5725V15.4312Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 12.0037H19.425V14.2837H20.5725V12.0037Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 7.42871H19.425V8.56871H20.5725V7.42871Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 17.7188H18.285V18.8588H19.425V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 8.56873H18.285V12.0037H19.425V8.56873Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 4.00122H18.285V5.14122H19.425V4.00122Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 18.8587H17.145V19.9987H18.285V18.8587Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 14.2838H17.145V15.4313H19.425V14.2838Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 5.14124H17.145V6.28874H18.285V5.14124Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 2.86121H17.145V4.00121H18.285V2.86121Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1451 15.4312H15.9976V16.5712H17.1451V15.4312Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1451 6.28876H15.9976V7.42876H17.1451V6.28876Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1451 1.71375H15.9976V2.86125H17.1451V1.71375Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9975 22.2863H14.8575V23.4263H15.9975V22.2863Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9975 16.5712H14.8575V17.7187H15.9975V16.5712Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9975 7.42871H14.8575V8.56871H15.9975V7.42871Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9975 0.57373H14.8575V1.71373H15.9975V0.57373Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8575 17.7188H13.7175V22.2863H14.8575V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7174 0.57373H12.5699V2.86123H13.7174V0.57373Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5701 2.86121H11.4301V6.28871H12.5701V2.86121Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.43 6.28876H10.2825V8.56876H11.43V6.28876Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2825 17.7188H9.14246V22.2863H10.2825V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14244 22.2863H8.00244V23.4263H9.14244V22.2863Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14244 16.5712H8.00244V17.7187H9.14244V16.5712Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14244 7.42871H8.00244V8.56871H9.14244V7.42871Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14244 0.57373H8.00244V1.71373H9.14244V0.57373Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00248 15.4312H6.85498V16.5712H8.00248V15.4312Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00248 6.28876H6.85498V7.42876H8.00248V6.28876Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00248 1.71375H6.85498V2.86125H8.00248V1.71375Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85497 18.8587H5.71497V19.9987H6.85497V18.8587Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85495 14.2838H4.57495V15.4313H6.85495V14.2838Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85497 5.14124H5.71497V6.28874H6.85497V5.14124Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85497 2.86121H5.71497V4.00121H6.85497V2.86121Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71495 17.7188H4.57495V18.8588H5.71495V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71495 8.56873H4.57495V12.0037H5.71495V8.56873Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71495 4.00122H4.57495V5.14122H5.71495V4.00122Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57499 22.2863H3.42749V23.4263H4.57499V22.2863Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57499 15.4312H3.42749V17.7187H4.57499V15.4312Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57499 12.0037H3.42749V14.2837H4.57499V12.0037Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57499 7.42871H3.42749V8.56871H4.57499V7.42871Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42748 19.9987H2.28748V22.2862H3.42748V19.9987Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42748 8.56873H2.28748V9.71623H3.42748V8.56873Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28751 17.7188H1.14001V19.9988H2.28751V17.7188Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28751 9.71625H1.14001V12.0037H2.28751V9.71625Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14 12.0037H0V17.7187H1.14V12.0037Z",
    fill: "#0d0d0d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsColor);
export default __webpack_public_path__ + "static/media/skills-color.c0c1f70702006f9fefdda67f3d4d726e.svg";
export { ForwardRef as ReactComponent };